module.exports = __webpack_public_path__ + "static/media/history_17.0959b979.jpg";